module.exports = __webpack_public_path__ + "media/images/www/company/delivery-truck-cargo-0765119876f8b047da7c6f6e440838e0.svg";